import InputAutocomplete from '@components/InputAutocomplete';
import { FormGroup, FormLabel } from '@mui/material';
import { useMemo } from 'react';
import { ITalentSearchFilterOption } from '../types';

interface TagFilterProps {
  name: string;
  options: ITalentSearchFilterOption[];
}

const TagFilter = ({ name, options }: TagFilterProps) => {
  const tagOptions = useMemo(() => {
    return options.map((tag) => ({
      value: tag.value,
      label: `${tag.label} (${tag.count})`,
    }));
  }, [options]);

  return (
    <FormGroup>
      <FormLabel>Tags</FormLabel>
      <InputAutocomplete
        id={name}
        name={name}
        multiple
        freeSolo
        options={tagOptions}
      />
    </FormGroup>
  );
};

export default TagFilter;
